import { AfterViewInit, Component, inject, input, output, viewChild } from '@angular/core';
import { IActionButton, Work } from '../../../models/work.model';
import { StockCreateFormComponent } from '../../../inventory/actions/form/create/stock-create-form/stock-create-form.component';
import { toUnderscore } from '../../../utils/string-utils';
import { AdminService } from '../../../admin/services/admin.service';
import { getRouteForElement } from '../../../utils/routes-utils';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { PricingCreateFormComponent } from '../../../inventory/actions/form/create/pricing-create-form/pricing-create-form.component';
import { InvoiceCreateFormComponent } from '../../../invoice/form/create/create.component';
import { BuyOrderCreateFormComponent } from '../../../inventory/actions/form/create/buy-order-create-form/buy-order-create-form.component';

const componentVariableNames = {
  'InventoryAction::BuyOrder': 'buyOrderCreateForm',
  'InventoryAction::Pricing': 'pricingCreateForm',
  'InventoryAction::Stock': 'stockCreateForm',
  'Invoice::Sale': 'invoiceCreateForm',
}

@Component({
    selector: 'wpl-create-document',
    templateUrl: './create-document.component.html',
    styleUrl: './create-document.component.scss',
    standalone: false
})
export class CreateDocumentComponent implements AfterViewInit {
  workInstance = input<Work>();

  actionButtons = output<IActionButton[]>();


  buyOrderCreateForm = viewChild(BuyOrderCreateFormComponent);

  invoiceCreateForm = viewChild(InvoiceCreateFormComponent);

  pricingCreateForm = viewChild(PricingCreateFormComponent);

  stockCreateForm = viewChild(StockCreateFormComponent);


  private readonly adminService = inject(AdminService);

  private readonly dialog = inject(MatDialog);

  private readonly router = inject(Router);

  ngAfterViewInit(): void {
    this.emitActionButtons();
  }

  onUpdate(): void {
    this.emitActionButtons();
  }

  get actionsMap() {
    return {
      'InventoryAction::Pricing': [
          {
            label: 'Solicitar Cotización',
            action: this[this.formComponent]().saveForm.bind(this[this.formComponent]()),
            enabled: this[this.formComponent]().formValid,
          }
      ],
      'InventoryAction::BuyOrder': [
          {
            label: 'Crear Orden de Compra',
            action: this[this.formComponent]().saveForm.bind(this[this.formComponent]()),
            enabled: this[this.formComponent]().formValid,
          }
      ],
      'InventoryAction::Stock': [
          {
            label: 'Ingresar Stock',
            action: this[this.formComponent]().saveForm.bind(this[this.formComponent]()),
            enabled: this[this.formComponent]().formValid,
          }
      ],
      'Invoice::Sale': [
          {
            label: 'Crear Documento Tributario',
            action: this[this.formComponent]().saveForm.bind(this[this.formComponent]()),
            enabled: this[this.formComponent]().formValid,
          }
      ],
    }
  }

  get formComponent() {
    return componentVariableNames[this.workInstance().work.custom_response_document_type]
  }

  get documentType() {
    return this.workInstance().generated_document?.type || this.workInstance().work.custom_response_document_type;
  }

  get humanReadableDocumentType() {
    return this.adminService.getText(toUnderscore(this.documentType));
  }

  get actions() {
    if (this.workInstance().completed_at || this.workInstance().generated_document) return [];

    return this.actionsMap[this.workInstance().work.custom_response_document_type];
  }

  goToDocument(document) {
    this.dialog.closeAll();
    this.router.navigate(getRouteForElement(document.type, document.id));
  }

  private emitActionButtons(): void {
    this.actionButtons.emit(this.actions);
  }
}
